import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/v1/admin/login',
    method: 'post',
    data
  })
}

export function getUserList(params) {
  return request({
    url: '/api/v1/admin/userlist',
    method: 'get',
    params
  })
}

export function addUser(data) {
  return request({
    url: '/api/v1/admin/userlist',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/api/v1/admin/userlist',
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/api/v1/admin/userlist/${id}`,
    method: 'delete'
  })
}


export function getProductCategoryList(params) {
  return request({
    url: '/api/v1/product_categories',
    method: 'get',
    params
  })
}

export function addProductCategory(data) {
  return request({
    url: '/api/v1/product_categories',
    method: 'post',
    data
  })
}

export function updateProductCategory(data) {
  return request({
    url: '/api/v1/product_categories/update',
    method: 'post',
    data
  })
}

// 上传文件
export function uploadFile(data) {
  return request({
    url: '/api/v1/upload/image',
    method: 'post',
    data
  })
}



export function deleteProductCategory(id) {
  return request({
    url: `/api/v1/product_categories/${id}`,
    method: 'delete'
  })
}

export function getNewsCategoryList(params) {
  return request({
    url: '/api/v1/news_categories',
    method: 'get',
    params
  })
}

export function addNewsCategory(data) {
  return request({
    url: '/api/v1/news_categories',
    method: 'post',
    data
  })
}

export function updateNewsCategory(data) {
  return request({
    url: '/api/v1/news_categories/update',
    method: 'post',
    data
  })
}

export function deleteNewsCategory(id) {
  return request({
    url: `/api/v1/news_categories/${id}`,
    method: 'delete'
  })
}

export function getNewsList(params) {
  return request({
    url: '/api/v1/news',
    method: 'get',
    params
  })
}

export function getNewsDetail(id) {
  return request({
    url: `/api/v1/news/item/${id}`,
    method: 'get',
    skipBizCodeCheck: true
  })
}

export function addNews(data) {
  return request({
    url: '/api/v1/news',
    method: 'post',
    data
  })
}

export function updateNews(data) {
  return request({
    url: '/api/v1/news/update',
    method: 'post',
    data
  })
}

export function deleteNews(id) {
  return request({
    url: `/api/v1/news/${id}`,
    method: 'delete'
  })
}

export function getCaseCategoryList(params) {
  return request({
    url: '/api/v1/anli_categories',
    method: 'get',
    params
  })
}

export function addCaseCategory(data) {
  return request({
    url: '/api/v1/anli_categories',
    method: 'post',
    data
  })
}

export function updateCaseCategory(data) {
  return request({
    url: '/api/v1/anli_categories/update',
    method: 'post',
    data
  })
}

export function deleteCaseCategory(id) {
  return request({
    url: `/api/v1/anli_categories/${id}`,
    method: 'delete'
  })
}

export function getProductList(params) {
  return request({
    url: '/api/v1/products',
    method: 'get',
    params
  })
}

export function getProductDetail(id) {
  return request({
    url: `/api/v1/products/item/${id}`,
    method: 'get',
    skipBizCodeCheck: true
  })
}
//产品列表新增
export function addProduct(data) {
  return request({
    url: '/api/v1/products',
    method: 'post',
    data
  })
}
//产品列表更新
export function updateProduct(data) {
  return request({
    url: '/api/v1/products/update',
    method: 'post',
    data
  })
}
//产品列表删除
export function deleteProduct(id) {
  return request({
    url: `/api/v1/products/${id}`,
    method: 'delete'
  })
}

export function getCaseList(params) {
  return request({
    url: '/api/v1/anlis',
    method: 'get',
    params
  })
}

export function getCaseDetail(id) {
  return request({
    url: `/api/v1/anlis/item/${id}`,
    method: 'get',
    skipBizCodeCheck: true
  })
}

export function addCase(data) {
  return request({
    url: '/api/v1/anlis',
    method: 'post',
    data
  })
}

export function updateCase(data) {
  return request({
    url: '/api/v1/anlis/update',
    method: 'post',
    data
  })
}

export function deleteCase(id) {
  return request({
    url: `/api/v1/anlis/${id}`,
    method: 'delete'
  })
}

export function getSolutionList(params) {
  return request({
    url: '/api/v1/solutions',
    method: 'get',
    params
  })
}

export function addSolution(data) {
  return request({
    url: '/api/v1/solutions',
    method: 'post',
    data
  })
}

export function updateSolution(data) {
  return request({
    url: '/api/v1/solutions/update',
    method: 'post',
    data
  })
}

export function deleteSolution(id) {
  return request({
    url: `/api/v1/solutions/${id}`,
    method: 'delete'
  })
}

/** 轮播图 Banner */
export function getBannerList(params) {
  return request({
    url: '/api/v1/banners',
    method: 'get',
    params
  })
}

export function getBannerDetail(id) {
  return request({
    url: `/api/v1/banners/${id}`,
    method: 'get'
  })
}

export function addBanner(data) {
  return request({
    url: '/api/v1/banners',
    method: 'post',
    data
  })
}

export function updateBanner(data) {
  return request({
    url: '/api/v1/banners/update',
    method: 'post',
    data
  })
}

export function deleteBanner(id) {
  return request({
    url: `/api/v1/banners/${id}`,
    method: 'delete'
  })
}
